export default __webpack_public_path__ + "static/media/arrow__right-white.2ea3d032.svg";